<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      便利度评估
      <div class="pt20">
        <zhengti @getactive="getactive"></zhengti>
      </div>
    </div>
    <div class="biaoti">
      企业开办综合变了度评估结果显示,上海综合得分最高,本市排名第2名,得分相差10
    </div>
    <div v-if="active==0" class="paiming2">
      <div class="body">
        <div class="bodyitem" v-for="(item,index) in list" :key="index">
          <div class="item1">{{ index + 1 }}</div>
          <div class="item2">
            <div class="items1">{{ item.title }}</div>
            <div class="items2">{{ item.fenshu }}分</div>
            <div class="items3">
              <img v-if="item.sheng" src="../../assets/shangsheng.png" alt="">
              <img v-else src="../../assets/xiajiang.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active==1">
      <bianlimx></bianlimx>
    </div>
  </div>
</template>

<script>
import zhengti from "@/components/qiyekaiban/zhengti";
// import mingxi from "@/components/qiyekaiban/pinggu/mingxi";
import bianlimx from "@/components/qiyekaiban/bianlimx";

export default {
  name: "paiming",
  components: {zhengti, bianlimx},
  data: function () {
    return {
      active: 0,
      list: [
        {
          title: '北京',
          fenshu: 90,
          sheng: true
        }, {
          title: '上海',
          fenshu: 80,
          sheng: true
        }, {
          title: '深圳',
          fenshu: 78,
          sheng: true
        }, {
          title: '大连',
          fenshu: 78,
          sheng: false
        }]

    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 100%;
}

.body {
  margin: auto;
}

.bodyitem {
  height: 121px;
  @include flex_between_center();
  margin-bottom: 40px;
  position: relative;

  .item1 {
    background: url("../../assets/paimingbg1.png") no-repeat;
    height: 106px;
    width: 105px;
    @include flex_center_center();
    position: absolute;
    font-size: 60px;
    font-family: PingFang;
    font-weight: 800;
    color: #fff;
  }

  .item2 {
    width: 705px;
    height: 121px;
    background: #192A63;
    @include flex_around_center();
    margin-left: 70px;

    .items1 {
      font-size: 40px;
      font-family: PingFang;
      font-weight: 800;
      color: #FFFFFF;
      width: 50%;
      @include flex_center_center();
    }

    .items2 {
      font-size: 40px;
      font-family: PingFang;
      font-weight: 800;
      color: #FFD54F;
    }
  }
}

.bodyitem:nth-child(2) {
  .item1 {
    background: url("../../assets/paimingbg2.png") no-repeat;
  }
}

.bodyitem:nth-child(3) {
  .item1 {
    background: url("../../assets/paimingbg3.png") no-repeat;
  }
}

.bodyitem:nth-child(4) {
  .item1 {
    background: url("../../assets/paimingbg4.png") no-repeat;
  }
}

.biaoti {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-bottom: 20px;
}
</style>
